module.exports = __webpack_public_path__ + "static/media/xb6.49627f29.png";